import React, { useCallback } from 'react';
import SafetyNotice from '../SafetyNotice';
import JobInformationSection from './JobInformationSection';
import ScopeSection from './ScopeSection';
import HazardsSection from './HazardsSection';
import EnergySourcesSection from './EnergySourcesSection';
import ErrorTrapsSection from './ErrorTrapsSection';
import HPToolsSection from './HPToolsSection';
import PPESection from './PPESection';

/**
 * PlanPhase — Phase B composition.
 *
 * All seven Plan-phase sections share a single `onChange({...patch})`
 * signature that merges into the parent draft. The parent Editor
 * autosave (1.2s debounce) picks up every mutation.
 *
 * Order intentionally matches the safety spec:
 *   1. Job Info   → 2. Scope     → 3. Hazards
 *   4. Energy     → 5. Error Traps → 6. HP Tools
 *   7. PPE
 */
export default function PlanPhase({ draft, onChange }) {
  const patch = useCallback((p) => onChange(p), [onChange]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }} data-testid="jbv2-plan-phase">
      <SafetyNotice />
      <JobInformationSection   draft={draft} onChange={patch} />
      <ScopeSection            draft={draft} onChange={patch} />
      <HazardsSection          draft={draft} onChange={patch} />
      <EnergySourcesSection    draft={draft} onChange={patch} />
      <ErrorTrapsSection       draft={draft} onChange={patch} />
      <HPToolsSection          draft={draft} onChange={patch} />
      <PPESection              draft={draft} onChange={patch} />
    </div>
  );
}
